/**
 * Detector de Locale - Usa GeolocationService unificado
 */

import { geolocationService } from '../services/geolocation.js';

/**
 * Detecta o locale ideal baseado em geolocalização cruzada
 * @returns {Promise<string>} Locale detectado
 */
export async function detectLocale() {
  const geo = await geolocationService.detect();

  return geo.locale;
}

/**
 * Obtém lista de locales suportados
 */
export function getSupportedLocales() {
  return [
    { code: 'pt-BR', name: 'Portuguese (Brazil)', nativeName: 'Português (Brasil)' },
    { code: 'pt-PT', name: 'Portuguese (Portugal)', nativeName: 'Português (Portugal)' },
    { code: 'en-US', name: 'English (US)', nativeName: 'English (US)' },
    { code: 'en-GB', name: 'English (UK)', nativeName: 'English (UK)' },
    { code: 'es-ES', name: 'Spanish (Spain)', nativeName: 'Español (España)' }
  ];
}

/**
 * Verifica se um locale é suportado
 */
export function isLocaleSupported(locale) {
  return ['pt-BR', 'pt-PT', 'en-US', 'en-GB', 'es-ES'].includes(locale);
}
